import React, { useEffect, useRef, useState } from 'react';
import { Box, Fade, Typography } from '@mui/material';
import * as styles from './links.module.scss';

export interface ILinksProps {
    title: string;
    subtitle: any;
    linksList: [
        {
            title: string;
            icon: string;
            redirect: string;
        },
    ];
}

const Links = ({ title, subtitle, linksList }: ILinksProps) => {
    const [isVisible, setIsVisible] = useState(false);
    const LinksRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting) {
                setIsVisible(entries[0].isIntersecting);
            }
        });
        if (LinksRef.current) {
            observer.observe(LinksRef.current);
        }
        return () => observer.disconnect();
    }, []);

    return (
        <Fade in={isVisible} timeout={1000}>
            <section ref={LinksRef}>
                <>
                    {subtitle && (
                        <Typography variant="body1" className="a-home__desc">
                            {subtitle}
                        </Typography>
                    )}
                    {title && (
                        <Typography component="h2" className="a-home__h2">
                            {title}
                        </Typography>
                    )}
                </>
                <Box className={styles.o_links}>
                    {linksList.map((link, index) => (
                        <a
                            key={index}
                            href={link.redirect}
                            rel="noreferrer follow"
                            target="_blank"
                            className={styles.o_links__link}
                        >
                            <div className={styles.o_links__icon}>
                                <i className={link.icon}></i>
                            </div>
                            <div className={styles.o_links__label}>
                                <Typography component="h3">
                                    {link.title}
                                </Typography>
                            </div>
                        </a>
                    ))}
                </Box>
            </section>
        </Fade>
    );
};

export default Links;
